module.exports = __webpack_public_path__ + "img/baner.5c29a1c3.svg";